/* ==========================================================================
   EMPIRE HOLLYWOOD — LUXE ENHANCE v6 : PRODUCT-PAGE COLOR SWITCH
   On a product page, if the product carries a metal-color token (White / Yellow
   / Rose Gold / Gold / Silver / Black), find the SAME product in the OTHER
   colors — sold as separate products — and show 1-tap "switch colour & buy"
   chips right above the Add-to-Cart form.

   DISCOVERY = BY NAME (owner's rule: "siblings = the colour-stripped product
   NAME matches"). This store's colour variants have wildly inconsistent HANDLES
   (e.g. the gold "Prism Cuban Chain - 20mm" lives at handle
   `infinity-twist-chain-15mm-18k-gold-コピー`; Tennis 3mm colours are
   `tennis-chain-3mm-rose-gold` vs `3mm-tennis-18k-white-gold-chain`), so handle
   matching fails — but the TITLES agree. We query the storefront search by the
   colour-stripped name, then keep only products whose colour-stripped name is
   IDENTICAL and whose colour differs. Because a necklace is "… Chain", a
   bracelet is "… Bracelet", a set is "… Set", and moissanite is "Moissanite …",
   name-equality naturally excludes all of those. ADDITIVE / fails silently.
   ========================================================================== */
(function(){
  if(window.__ehColorSwitch) return; window.__ehColorSwitch = true;

  var COLORS = [
    {key:'wg', re:/\bwhite\s*gold\b|ホワイトゴールド|\bwg\b/i,        hslug:'white-gold',  label:'ホワイトゴールド', sw:'linear-gradient(135deg,#f4f6f7,#d7dee1)'},
    {key:'yg', re:/\byellow\s*gold\b|イエローゴールド/i,             hslug:'yellow-gold', label:'イエローゴールド', sw:'linear-gradient(135deg,#f1d580,#d4a53c)'},
    {key:'rg', re:/\brose\s*gold\b|ローズゴールド|ピンクゴールド/i,    hslug:'rose-gold',   label:'ローズゴールド',   sw:'linear-gradient(135deg,#f0c3b4,#d78e79)'},
    {key:'g',  re:/\bgold\b|ゴールド/i,                             hslug:'gold',        label:'ゴールド',         sw:'linear-gradient(135deg,#f1d580,#d4a53c)'},
    {key:'s',  re:/\bsilver\b|シルバー/i,                            hslug:'silver',      label:'シルバー',         sw:'linear-gradient(135deg,#eef1f2,#c7ced0)'},
    {key:'k',  re:/\bblack\b|ブラック/i,                            hslug:'black',       label:'ブラック',         sw:'linear-gradient(135deg,#4a4a4a,#1d1d1d)'}
  ];
  var CRE = /(?:18k-|14k-|10k-)?(white-gold|rose-gold|yellow-gold|gold|silver|black)/i;
  var ORDER = {wg:0, g:1, yg:2, rg:3, s:4, k:5};

  function detect(s){ s = s || ''; for(var i=0;i<COLORS.length;i++){ if(COLORS[i].re.test(s)) return COLORS[i]; } return null; }
  function abs(u){ if(!u) return ''; return (u.indexOf('//') === 0) ? ('https:' + u) : u; }
  /* the product NAME, with promo badges and colour/karat words stripped */
  function base(title){
    var b = title || '';
    b = b.replace(/【[^】]*】/g,' ').replace(/〔[^〕]*〕/g,' ');           /* 【人気No.1】 etc. promo badges */
    b = b.replace(/[\(（\[［【][^)）\]］】]*(?:white\s*gold|yellow\s*gold|rose\s*gold|gold|silver|black|plated)[^)）\]］】]*[\)）\]］】]/ig,' ');
    b = b.replace(/(?:ホワイト|イエロー|ローズ|ピンク)?(?:ゴールド|シルバー|ブラック)/g,' ');
    b = b.replace(/\b(?:18k|14k|10k)\b/ig,' ');
    b = b.replace(/\bplated\b/ig,' ');
    b = b.replace(/\b(white\s*gold|yellow\s*gold|rose\s*gold|gold|silver|black)\b/ig,' ');
    b = b.replace(/[\(（\[［【】\)）\]］]/g,' ').replace(/[-–—•|/]/g,' ').replace(/\s+/g,' ').trim().toLowerCase();
    return b;
  }
  function ready(fn){ if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  ready(function(){
    try{
      if(!document.body.classList.contains('template-product')) return;
      if(document.querySelector('.eh-csw')) return;
      var m = location.pathname.match(/\/products\/([^\/?#]+)/); if(!m) return;
      var handle = decodeURIComponent(m[1]);

      fetch('/products/' + handle + '.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(prod){
          var title = (prod && prod.title) || '';
          var cur = detect(title) || detect(handle);
          if(!cur) return;                                    /* no colour → not a colour set */
          var curBase = base(title); if(curBase.length < 2) return;

          /* fallback candidate handles by colour-swap, used only if search fails */
          function swapCands(){
            var out = [], mm = handle.match(CRE); if(!mm) return out; var region = mm[0], seen = {};
            COLORS.forEach(function(c){ if(c.key === cur.key) return;
              ['', '18k-'].forEach(function(pre){ var h = handle.replace(region, pre + c.hslug); if(h !== handle && !seen[h]){ seen[h]=1; out.push(h); } }); });
            return out;
          }

          /* PRIMARY: storefront search by the colour-stripped name → candidate handles */
          fetch('/search?q=' + encodeURIComponent(curBase) + '&type=product&options%5Bprefix%5D=last', {headers:{'Accept':'text/html'}})
            .then(function(r){ return r.ok ? r.text() : ''; })
            .catch(function(){ return ''; })
            .then(function(html){
              var cands = [], seenH = {};
              if(html){ var re = /\/products\/([A-Za-z0-9%_.\-]+)/g, mm2; while((mm2 = re.exec(html))){ var h = mm2[1]; if(!seenH[h]){ seenH[h]=1; cands.push(h); } } }
              if(!cands.length){ swapCands().forEach(function(h){ if(!seenH[h]){ seenH[h]=1; cands.push(h); } }); }
              cands = cands.filter(function(h){ return h !== handle && h !== encodeURIComponent(handle); }).slice(0, 24);

              return Promise.all(cands.map(function(h){
                return fetch('/products/' + h + '.js', {headers:{'Accept':'application/json'}})
                  .then(function(r){ return r.ok ? r.json() : null; })
                  .then(function(p){
                    if(!p || !p.handle || p.handle === handle) return null;
                    if(base(p.title) !== curBase) return null;   /* SIBLING = identical colour-stripped NAME */
                    var c = detect(p.title); if(!c) return null;
                    return {url:'/products/' + p.handle, image:abs(p.featured_image || (p.images && p.images[0]) || ''), color:c};
                  })
                  .catch(function(){ return null; });
              }));
            })
            .then(function(found){
              var sibs = [], seen = {}; seen[cur.key] = 1;
              (found || []).forEach(function(s){ if(s && s.color.key !== cur.key && !seen[s.color.key]){ seen[s.color.key] = 1; sibs.push(s); } });
              if(sibs.length) render(cur, sibs);
            })
            .catch(function(){});
        })
        .catch(function(){});
    }catch(e){}
  });

  function render(cur, sibs){
    if(!sibs.length || document.querySelector('.eh-csw')) return;
    sibs.sort(function(a,b){ return (ORDER[a.color.key] == null ? 9 : ORDER[a.color.key]) - (ORDER[b.color.key] == null ? 9 : ORDER[b.color.key]); });

    var wrap = document.createElement('div'); wrap.className = 'eh-csw';
    var h = '<div class="eh-csw__label">カラーを選ぶ</div><div class="eh-csw__row">';
    h += '<span class="eh-csw__chip" data-current><span class="eh-csw__sw" style="background:' + cur.sw + '"></span>' + cur.label + '</span>';
    sibs.forEach(function(s){
      var media = s.image ? ('<img src="' + s.image + '" alt="" loading="lazy">') : ('<span class="eh-csw__sw" style="background:' + s.color.sw + '"></span>');
      h += '<a class="eh-csw__chip" href="' + s.url + '">' + media + s.color.label + '</a>';
    });
    h += '</div>';
    wrap.innerHTML = h;

    /* place ABOVE the MAIN add-to-cart form (not the "buy together" form) */
    var form = document.getElementById('form-simple-addtocart');
    if(!form){
      var fs = document.querySelectorAll('form[action*="/cart/add"]');
      for(var i=0;i<fs.length;i++){ if(fs[i].id !== 'buy_together_form'){ form = fs[i]; break; } }
    }
    if(form && form.parentNode){ form.parentNode.insertBefore(wrap, form); return; }
    var t = document.querySelector('.product-single__title, .product-title, .product__title, h1:not(.d-none)');
    if(t && t.parentNode){ t.parentNode.insertBefore(wrap, t.nextSibling); }
  }
})();
